// extracted by mini-css-extract-plugin
module.exports = {"card":"EvaneosSocialMediaCard_card__rQbUq","illustration":"EvaneosSocialMediaCard_illustration__Guu1m","title":"EvaneosSocialMediaCard_title__ihSrf"};